export function getItemTypeIcon(fileName = ''): string {
  const name = fileName.toLocaleLowerCase();
  if (name.endsWith('.bmp')) {
    return `assets/images/file-bmp.svg`;
  } else if (name.endsWith('.csv')) {
    return `assets/images/file-csv.svg`;
  } else if (name.endsWith('.doc') || name.endsWith('.docx')) {
    return `assets/images/file-doc.svg`;
  } else if (name.endsWith('.jpg') || name.endsWith('.jpeg')) {
    return `assets/images/file-jpg.svg`;
  } else if (name.endsWith('.mov')) {
    return `assets/images/file-mov.svg`;
  } else if (name.endsWith('.mp3')) {
    return `assets/images/file-mp3.svg`;
  } else if (name.endsWith('.pdf')) {
    return `assets/images/file-pdf.svg`;
  } else if (name.endsWith('.png')) {
    return `assets/images/file-png.svg`;
  } else if (name.endsWith('.svg')) {
    return `assets/images/file-svg.svg`;
  } else if (name.endsWith('.xls') || name.endsWith('.xlsx')) {
    return `assets/images/file-xls.svg`;
  } else {
    return `assets/images/file-unknown.svg`;
  }
}
